<template>
  <div class="txtbox" :class='{"editTxt":edit}'>
    <div class="txtItem" v-for='(i,index) in contentList' :key='index' :style="{'height':Hei || '82px'}">
      <div class="textarea" :class="{'onlTxt':!more}">
        <a-input type="textarea" v-model='i.content' @input='leave(index)' :disabled='edit'></a-input>
        <div class="time" v-if='i.content_time'>
          <b>
            <span v-show="!never" style="padding-right:10px;">{{i.content_user}}</span>
          </b>
          <span>{{i.content_time | timer}}</span>
        </div>
      </div>
      <div class="btns" v-if='!edit && more'>
        <a-icon type="plus-circle" class="i add" @click='add' v-if='index==contentList.length-1' style="margin-right:10px;" />
        <a-icon type="minus-circle" class="i del" @click='del(index)' v-if='contentList.length>1' />
      </div>
    </div>
  </div>
</template>
<script>
import { dateFormat } from "@/assets/js/formData"
export default {
  props: {
    Hei: String,
    never: Boolean,    //特殊不需要处理
    keyArr: Array,
    more: {
      type: Boolean,
      default() {
        return true
      }
    },
    content: {
      type: Array,
      default() {
        return [{ content: '', content_user: '', content_time: '' }]
      }
    },
    edit: Boolean
  },
  data() {
    return {
      contentList: []
    }
  },
  watch: {
    content: {
      handler(newVal) {
        if (newVal && this.keyArr) {
          let contentList = [];
          newVal.map(ele => {
            let obj = {}
            obj.content_time = ele[this.keyArr[0]]
            obj.content_user = ele[this.keyArr[1]]
            obj.content = ele.content
            contentList.push(obj)
          })
          this.contentList = contentList
        } else {
          this.contentList = newVal
        }
      },
      immediate: true
    }
  },
  filters: {
    timer(val) {
      if (val) {
        return val.slice(0, 16)
      } else {
        return ''
      }
    }
  },
  methods: {
    leave(index, e) {
      // console.log(index)
      let content = JSON.parse(JSON.stringify(this.contentList))
      if (!content[index].content_time || new Date().getTime() > new Date(content[index].content_time).getTime()) {
        content[index].content_time = dateFormat(new Date())
        content[index].content_user = this.$store.state.user.uname
      }
      this.contentList = content
      this.putValue()
    },
    add(index) {
      this.contentList.push({ content: '', content_user: '' })
    },
    del(index) {
      let content = JSON.parse(JSON.stringify(this.contentList))
      content.splice(index, 1)
      this.contentList = content
      this.putValue()
    },
    putValue() {
      if (this.never) {
        let contentList = this.contentList.filter(ele => {
          return ele.content_time
        })
        this.$emit("contentVal", contentList)
      } else {
        let contentList = [];
        this.contentList.map(ele => {
          let obj = {}
          obj[this.keyArr[0]] = ele.content_time
          obj[this.keyArr[1]] = ele.content_user
          obj.content = ele.content
          contentList.push(obj)
        })
        this.$emit("contentVal", contentList)
      }

    }
  }
}
</script>
<style lang="less" scoped>
.editTxt {
  .txtItem {
    .textarea {
      background: none;
      border-radius: 4px;
      width: 100%;
      border: 1px solid #333;
    }
  }
}
.txtItem {
  margin-bottom: 20px;
  display: flex;
  height: 82px;
  position: relative;
  .btns {
    width: 15%;
    max-width: 70px;
    display: flex;
    font-size: 20px;
    justify-content: space-between;
    padding-left: 20px;
    height: 30px;
    .i {
      cursor: pointer;
    }
    .add {
      color: #b0e0e6;
    }
    .del {
      color: #f00;
    }
  }
  &:nth-last-child(1) {
    margin-bottom: 20px;
  }
}
.textarea {
  border: 1px solid #efefef;
  background: #fff;
  width: 85%;
  padding: 4px 10px;
  textarea {
    width: 100%;
    border: 0 none;
    line-height: 20px;
    vertical-align: top;
    height: 90%;
    background: none;
    position: relative;
    border: 0 none!important;
    box-shadow: none;
  }
  .time {
    line-height: 20px;
    color: rgba(0, 0, 0, 0.3);
    text-align: right;
    /* margin-top: 5%; */
    width: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    position: absolute;
    font-size: 12px;
    bottom: -20px;
  }
}
.onlTxt {
  width: 100%;
}
</style>